/* eslint-disable react/require-default-props */
import React from 'react';
import { Modal } from '@ui/molecules/Modal/Modal';
import { ModalHeader } from '@ui/molecules/Modal/ModalHeader';
import { ModalBody } from '@ui/molecules/Modal/ModalBody';
import { ModalFooter } from '@ui/molecules/Modal/ModalFooter';
import { Button } from '@ui/atoms/Button/Button';
import { Text } from '@ui/atoms/Text/Text';
import './TosModalStyles.scss';
const TOS_URL = 'https://www.inspectpoint.com/terms-of-service/';
const TITLE_ID = 'ai-tos-modal-title';
const BASE_CLASS = 'ai-tos-modal';
const TOS_SECTIONS = [
    {
        heading: "You're responsible for your inputs",
        body: 'Only share data you have the right to use.'
    },
    {
        heading: 'AI can be wrong',
        body: 'Responses may be inaccurate or incomplete. Review answers before relying on them.'
    },
    {
        heading: 'Not for unreviewed compliance work',
        body: "Don't use IP Assistant as the sole basis for an inspection sign-off, code interpretation, or AHJ submission. A qualified professional must validate any AI output used in regulated work."
    }
];
function TosModalContent({ onAccept, isSubmitting, error }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: "\uD83D\uDC4B Welcome to IP Assistant", titleId: TITLE_ID, showDivider: false }),
        React.createElement(ModalBody, { className: `${BASE_CLASS}__body` },
            React.createElement(Text, { variant: "body", as: "p", className: `${BASE_CLASS}__intro` }, "Before we get started, a few things to know:"),
            React.createElement("ul", { className: `${BASE_CLASS}__sections` }, TOS_SECTIONS.map((section) => (React.createElement("li", { key: section.heading, className: `${BASE_CLASS}__section` },
                React.createElement(Text, { variant: "small", as: "strong", className: `${BASE_CLASS}__section-heading` }, section.heading),
                React.createElement(Text, { variant: "body", as: "p", className: `${BASE_CLASS}__section-body` }, section.body)))))),
        React.createElement(ModalFooter, { startActions: React.createElement(Text, { variant: "body", as: "p", className: `${BASE_CLASS}__tos-statement` },
                "By continuing, you agree to our",
                ' ',
                React.createElement("a", { href: TOS_URL, target: "_blank", rel: "noopener noreferrer", className: `${BASE_CLASS}__tos-link` }, "Terms of Service"),
                ".") },
            error && (React.createElement(Text, { variant: "small", as: "p", className: `${BASE_CLASS}__error` }, error)),
            React.createElement(Button, { variant: "primary", onClick: onAccept, disabled: isSubmitting, "aria-busy": isSubmitting }, isSubmitting ? 'Processing...' : 'Continue'))));
}
function noop() {
    // TosModal is intentionally non-dismissible
}
export function TosModal({ isOpen, onAccept, isSubmitting = false, error, anchor }) {
    return (React.createElement(Modal, { isOpen: isOpen, onClose: noop, dismissOnBackdropClick: false, ariaLabelledBy: TITLE_ID, className: `${BASE_CLASS}__modal`, container: anchor !== null && anchor !== void 0 ? anchor : undefined },
        React.createElement(TosModalContent, { onAccept: onAccept, isSubmitting: isSubmitting, error: error })));
}
